import { post } from "../lib";

const { REACT_APP_API_URL } = process.env;

export const authApi = {
	login: (org: string, username: string, password: string) => post(`${REACT_APP_API_URL}/user/login`, { org, username, password }),
	forgotPassword: (email: string) => post(`${REACT_APP_API_URL}/user/password/forgot`, { email }),
	exchangeToken: (token: string) => post(`${REACT_APP_API_URL}/user/token`, { token })
};